import { isCustomFieldValueEmpty } from 'utils/customFields';
/** Returns warning message (if necessary) to be used in fields. */
export function getConversationCustomFieldsFormWarningMessage(customField, isAcw, isFlagEnabled = false) {
    if (isFlagEnabled &&
        isAcw &&
        customField.attribute.is_required &&
        isCustomFieldValueEmpty(customField.value)) {
        return 'Please fill in this required attribute';
    }
}
